// tslint:disable-next-line
var markdown = require("prosemirror-markdown");
// tslint:disable-next-line
var Node = require("prosemirror-model").Node;
var DcImageLinkBlock = /** @class */ (function () {
    function DcImageLinkBlock() {
    }
    DcImageLinkBlock.prototype.canSerialize = function (schema, node) {
        return node.type === "dc-image-link";
    };
    DcImageLinkBlock.prototype.serialize = function (schema, nodes) {
        return nodes.map(function (node) {
            return {
                type: "dc-image-link",
                data: node.attrs.value
            };
        });
    };
    DcImageLinkBlock.prototype.canParse = function (schema, block) {
        return block.type === "dc-image-link";
    };
    DcImageLinkBlock.prototype.parse = function (schema, blocks) {
        var result = [];
        blocks.forEach(function (block) {
            result.push({
                type: "dc-image-link",
                attrs: {
                    value: block.data
                }
            });
        });
        return result;
    };
    return DcImageLinkBlock;
}());
export default DcImageLinkBlock;
